import {
  breakpoints,
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const toolbarStyles = stylex.create({
  bar: {
    backgroundColor: colors.foreground,
    color: colors.inverse,
    position: "sticky",
    top: "var(--site-header-height, 0px)",
    zIndex: 40,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
  },
  row: {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: spacing.space8,
    justifyContent: "space-between",
    marginInline: "auto",
    maxWidth: 1200,
    paddingBlock: spacing.space8,
    paddingInline: {
      default: spacing.space24,
      [breakpoints.compact]: spacing.space16,
    },
  },
  status: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: spacing.space12,
    minWidth: 0,
  },
  description: {
    display: { default: "inline", [breakpoints.compact]: "none" },
  },
  compactLabel: {
    display: { default: "none", [breakpoints.compact]: "inline" },
  },
  muted: { color: colors.inverseMuted },
  actions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: spacing.space6,
  },
  notice: {
    borderBlockStartColor: colors.inverseMuted,
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: 1,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space8,
    marginInline: "auto",
    maxWidth: 1200,
    paddingBlock: spacing.space8,
    paddingInline: {
      default: spacing.space24,
      [breakpoints.compact]: spacing.space16,
    },
  },
  conflict: { backgroundColor: colors.danger, color: colors.inverse },
  list: {
    display: "grid",
    gap: spacing.space4,
    margin: 0,
    paddingInlineStart: spacing.space16,
  },
});
